/* eslint-disable */
<template>
  <section class="shoprent-page">
    <vue-basic-alert :duration="400" ref="alert" />

    <!-- ── Not Logged In ── -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to continue with your shop rent payment.</p>
        <router-link class="login-btn" to="/login" @click="scrollToTop()">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- ── Logged In ── -->
    <div v-else class="page-body">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Online Payments | මාර්ගගත ගෙවීම්</p>
            <h1 class="page-title">Shop Rents</h1>
            <p class="page-subtitle">කඩ කාමර කුලී ගෙවීම | Pay your shop rent online</p>
          </div>
        </div>
        <router-link to="/shoprentpayhistory" class="history-btn" @click="scrollToTop()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Payment History
        </router-link>
      </div>

      <form id="ShopRentForm" @submit="handleSubmit" novalidate autocomplete="off">

        <!-- ── Sabha Selection ── -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Select Pradeshiya Sabha</h2>
              <p class="card-desc">ඔබගේ කඩ කාමරය අයත් ප්‍රාදේශීය සභාව තෝරන්න | Choose the council your shop belongs to</p>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label" for="pradeshiya">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              Pradeshiya Sabha <span class="req">*</span>
            </label>
            <div class="input-wrap">
              <select @change="AllShopData" v-model="rentObj.pra_sabha" id="pradeshiya"
                class="field-input select-input" :class="{ filled: rentObj.pra_sabha }">
                <option value="" disabled>Choose Sabha | සභාව තෝරන්න</option>
                <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">
                  {{ ps.sb_name_en }} | {{ ps.sb_name_sin }}
                </option>
              </select>
              <div class="select-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
            </div>
            <p class="error-mess" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
          </div>
        </div>

        <!-- ── Shop List + Remarks ── -->
        <div id="pay" style="display:none;">

          <div class="info-banner">
            <div class="info-icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="info-text">
              <p>The details of the shops registered under your name are shown below. Select one shop at a time and make separate payments for each shop.</p>
              <p class="sin-text">ඔබ තෝරාගත් ආයතනයේ ඔබේ නමින් ඇති කඩ කාමර වල තොරතුරු පහතින් පෙන්වයි. එක වරකදී එක කඩ කාමරයක් පමණක් තෝරා වෙන වෙනම ගෙවීම් සිදු කරන්න.</p>
            </div>
          </div>

          <!-- Shop Table -->
          <div class="form-card">
            <div class="card-header">
              <div class="step-badge">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 7a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V7zm0 6h18M3 17h18"/>
                </svg>
              </div>
              <div>
                <h2 class="card-title">Your Registered Shops</h2>
                <p class="card-desc">ඔබේ නමින් ලියාපදිංචි කඩ කාමර | Select a shop to proceed with payment</p>
              </div>
            </div>

            <div class="table-wrap">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Last Payment<br><span class="th-sub">Year – Month</span></th>
                    <th>Next Payment<br><span class="th-sub">Year – Month</span></th>
                    <th>Market / Street / Place</th>
                    <th>Shop No.</th>
                    <th class="num-col">Rent<br><span class="th-sub">(Rs.)</span></th>
                    <th class="num-col">Fine<br><span class="th-sub">(Rs.)</span></th>
                    <th class="num-col">Arrears<br><span class="th-sub">(Rs.)</span></th>
                    <th class="num-col">Total<br><span class="th-sub">(Rs.)</span></th>
                    <th class="center-col">Select<br><span class="th-sub">to Pay</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="computedShopDetails.length === 0">
                    <td colspan="9" class="empty-row">No shop records found for the selected Sabha.</td>
                  </tr>
                  <tr v-for="r in computedShopDetails" :key="r.shop_details_id"
                    :class="{ 'selected-row': checkVal.includes(r.shop_details_id) }">
                    <td class="month-cell">{{ r.pay_year }} – {{ getMonthName(r.pay_month - 1) }}</td>
                    <td class="month-cell">
                      <span v-if="r.pay_month > (currentDate.getMonth()+1) && r.pay_year == currentDate.getFullYear()">
                        {{ currentDate.getFullYear() }} – {{ getMonthName(r.pay_month) }}
                      </span>
                      <span v-else-if="r.pay_month < (currentDate.getMonth()+1) && r.pay_year == currentDate.getFullYear()">
                        {{ currentDate.getFullYear() }} – {{ getMonthName(currentDate.getMonth()) }}
                      </span>
                      <span v-else-if="r.pay_month < (currentDate.getMonth()+1) && r.pay_year > currentDate.getFullYear()">
                        {{ currentDate.getFullYear()+1 }} – {{ getMonthName(r.pay_month) }}
                      </span>
                      <span v-else-if="r.pay_month > (currentDate.getMonth()+1) && r.pay_year > currentDate.getFullYear()">
                        {{ currentDate.getFullYear()+1 }} – {{ getMonthName(r.pay_month) }}
                      </span>
                      <span v-else>{{ currentDate.getFullYear() }} – {{ getMonthName(currentDate.getMonth()) }}</span>
                    </td>
                    <td>{{ r.place }}</td>
                    <td class="shop-num">{{ r.shop_number }}</td>
                    <td class="num-col">{{ r.monthly_shop_rent }}</td>
                    <td class="num-col fine-col">{{ r.fine }}</td>
                    <td class="num-col">{{ r.arrears }}</td>
                    <td class="num-col total-col">{{ r.totalAmount }}</td>
                    <td class="center-col">
                      <label class="custom-check-wrap">
                        <input type="checkbox" v-model="checkVal" :value="r.shop_details_id" class="hidden-check"/>
                        <div class="custom-check" :class="{ checked: checkVal.includes(r.shop_details_id) }">
                          <svg v-if="checkVal.includes(r.shop_details_id)" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
                          </svg>
                        </div>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Remarks + Submit -->
          <div class="form-card">
            <div class="card-header">
              <div class="step-badge">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
              </div>
              <div>
                <h2 class="card-title">Payment Remarks</h2>
                <p class="card-desc">ගෙවීම් විස්තරය | Add a description for this payment</p>
              </div>
            </div>

            <div class="field-group">
              <label class="field-label" for="rentShopdes">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                </svg>
                Remarks | ගෙවීම් විස්තරය
              </label>
              <textarea id="rentShopdes" class="field-input field-textarea"
                placeholder="Type your payment description here..."
                v-model="rentObj.rentdes"
                :class="{ filled: rentObj.rentdes }"></textarea>
              <p class="error-mess" v-if="errorObj.rentdesErr.length > 0">{{ errorObj.rentdesErr[0] }}</p>
            </div>

            <div class="form-actions">
              <div class="selection-summary" v-if="checkVal.length > 0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                {{ checkVal.length }} shop{{ checkVal.length > 1 ? 's' : '' }} selected
              </div>
              <div class="no-selection" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                Please select a shop to continue
              </div>
             
              <button type="submit" class="submit-btn" :disabled="checkVal.length === 0">
                Continue to Payment
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- ── No Shops Found ── -->
        <div id="pay2" style="display:none;">
          <div class="form-card notice-card">
            <div class="notice-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div>
              <h3 class="notice-title">No Shops Found</h3>
              <p class="notice-msg">No shop records were found for this Sabha under your name. Please select the correct council.</p>
              <p class="notice-sin">ඔබගේ කඩ කාමර කුලිය ගෙවීම සඳහා, ඔබගේ කඩ කාමරය අයත් සභාව නිවැරදිව තෝරන්න.</p>
            </div>
          </div>
        </div>

      </form>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert';

export default {
  name: "ShopRentExist",
  components: { VueBasicAlert },
  data() {
    return {
      userNic: '', Nic: '',
      rentObj: { pro: "", dis: "", pra_sabha: "", rentdes: "", month: "", year: "", checkbval: "", Payble: "", Arrears: "" },
      errorObj: { disErr: [], proErr: [], praErr: [], rentdesErr: [], monthErr: [], yearErr: [], payamountErr: [], PaybleErr: [], ArrearsErr: [], fineErr: [] },
      p_sabha: [], SabhaData: undefined, Sabha: undefined,
      matchUser: undefined, matchPaymonth: [],
      checkVal: [], payamount: {}, finecheck: [], payfine: {},
      AllShopDetails: [], Districts: [], province: [],
      len: 0, len2: 0, currentDate: new Date(),
      Mpayment: 0, curArrears: 0, monthDiff: 0,
      onlinPaydata: [], nextid: '', sabhaCode: "", finedate: 0, fineRate: 0,
    };
  },
  created() {
    this.getSessionData();
    this.AllprSabha();
  },
  computed: {
    ...mapState(["user"]),
    years() {
      const year = new Date().getFullYear();
      return Array.from({ length: year - 2020 }, (_, i) => 2020 + i + 1);
    },
    computedShopDetails() {
      return this.AllShopDetails.map(r => {
        const payment = this.getPaymentOfMonth(r.pay_month, r.monthly_shop_rent, r.pay_year);
        const [arrears, totalAmount, fine] = this.DiffOfMonths(r.pay_month, r.monthly_shop_rent, r.arrears, r.pay_year, r.fine_date, r.fine_month_count, r.fine_rate);
        return { ...r, payment, arrears, fine, totalAmount };
      });
    },
  },
  methods: {
    ...mapMutations(["setUser"]),
    scrollToTop() { window.scrollTo(0, 0); },
    async MatchUser(nic) {
      const data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },
    isGreaterThan10th(fdate, fmonth) {
      const today    = new Date(this.serverDate);
      const fineDate = new Date(today.getFullYear(), today.getMonth() + fmonth, fdate);
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const fineOnly  = new Date(fineDate.getFullYear(), fineDate.getMonth(), fineDate.getDate());
      return todayOnly > fineOnly;
    },
    getMonthName(monthNumber) {
      const date = new Date(this.serverDate);
      date.setMonth(monthNumber);
      return date.toLocaleString('en-US', { month: 'long' });
    },
    getPaymentOfMonth(monp, rent, pay_year) {
      const cm = this.currentDate.getMonth() + 1;
      const cy = this.currentDate.getFullYear();
      if (monp === cm && pay_year === cy) return '0.00';
      return parseFloat(rent);
    },
    DiffOfMonths(pm, cr, curAre, pay_year, fdate, fmonth, frate) {
      this.curArrears = curAre; let monthDiff = 0;
      const currentMonth = this.currentDate.getMonth() + 1;
      const currentYear  = this.currentDate.getFullYear();
      const monthlyRent  = parseFloat(cr);
      const fineRatePercentage = parseFloat(frate) / 100;
      const currentYearMonth = currentYear * 12 + currentMonth;
      const paidYearMonth    = pay_year * 12 + pm;
      let checkMonth1 = monthlyRent;
      if (pm === currentMonth && pay_year === currentYear)
        return [parseFloat(curAre).toFixed(2), parseFloat(checkMonth1).toFixed(2), "0.00"];
      if (paidYearMonth > currentYearMonth)
        return [parseFloat(curAre).toFixed(2), parseFloat(checkMonth1).toFixed(2), "0.00"];
      monthDiff = currentYearMonth - paidYearMonth;
      if (fmonth > 0) monthDiff--;
      this.curArrears = monthDiff > 0
        ? (monthlyRent * monthDiff - parseFloat(cr)) + parseFloat(curAre)
        : parseFloat(curAre);
      checkMonth1 = this.getPaymentOfMonth(pm, cr, pay_year);
      let fine = 0, numarr = 0;
      const totalAmountRent = parseFloat(checkMonth1) + parseFloat(this.curArrears);
      numarr = this.curArrears > 0 ? parseFloat(this.curArrears) / monthlyRent : 0;
      if (this.isGreaterThan10th(fdate, fmonth) && frate > 0 && checkMonth1 !== 0) numarr += 1;
      fine = this.curArrears > 0
        ? (numarr > 0 ? monthlyRent * fineRatePercentage * numarr : 0)
        : (numarr > 0 ? totalAmountRent * fineRatePercentage * numarr : 0);
      const totalAmountShop = parseFloat(this.curArrears) + parseFloat(checkMonth1) + parseFloat(fine);
      return [this.curArrears.toFixed(2), totalAmountShop.toFixed(2), fine.toFixed(2)];
    },
    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data) { this.Nic = data.Unic; this.sabhaCode = data.Usabha; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
      try {
        const res = await axios.get('/getserverdate');
        this.serverDate  = res.data.serverDate;
        this.currentDate = new Date(this.serverDate);
      } catch (e) { console.error("Error fetching server date:", e); }
      await axios.delete('/shoprentstemp/' + this.user.cus_nic);
      await axios.delete('/onlinepaymenttemp/' + this.user.cus_nic);
      window.sessionStorage.removeItem('rentDetails');
      window.sessionStorage.removeItem('shopDataid');
    },
    async AllprSabha() {
      try {
        const res = await axios.get('/customersabha/' + this.Nic);
        const all = res.data;
        if (all && all.length > 0) {
          this.p_sabha = [];
          for (const sabha of all) {
            if (sabha.sabha) {
              const r = await axios.get('/PraSabhadata/' + sabha.sabha);
              this.p_sabha.push(...r.data);
            }
          }
        }
      } catch (e) { console.error('Error fetching sabha data:', e); }
    },
    async AllShopData() {
      try {
        const shopData = (await axios.get('/shopdata/' + this.Nic + '/' + this.rentObj.pra_sabha)).data;
        this.AllShopDetails = shopData;
        const theSabha = (await axios.get('/pra_sabha/' + this.rentObj.pra_sabha)).data;
        this.finedate = theSabha.fine_date;
        this.fineRate = theSabha.fine_rate;
        document.getElementById('pay').style.display  = shopData.length ? 'block' : 'none';
        document.getElementById('pay2').style.display = shopData.length ? 'none'  : 'block';
      } catch (e) { console.error("Error in AllShopData():", e); }
    },
    resetCheckErr() {
      this.errorObj.disErr = []; this.errorObj.proErr = []; this.errorObj.praErr = [];
      this.errorObj.monthErr = []; this.errorObj.yearErr = []; this.errorObj.rentdesErr = [];
      this.errorObj.payamountErr = [];
    },
    checkEmptyErr() {
      for (var t in this.errorObj) { if (this.errorObj[t].length !== 0) return false; }
      return true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      if (!this.checkEmptyErr()) return;
      if (!this.user) { this.$refs.alert.showAlert('error', 'Please Login to Continue!'); return; }
      this.len2 = Object.keys(this.payamount).length;
      sessionStorage.setItem('shopDataid', JSON.stringify(this.checkVal));
      this.onlinPaydata = (await axios.get('/genarateinvonline/' + this.rentObj.pra_sabha)).data;
      let lastGennum = parseInt(this.onlinPaydata[0].gen_num);
      let InvouceNum = this.rentObj.pra_sabha.concat(
        this.currentDate.getMonth() + 1, this.currentDate.getFullYear(), lastGennum
      );
      this.nextid = lastGennum + 1;
      await axios.put('/updateinvonline/' + this.rentObj.pra_sabha, { gen_num: this.nextid });
      sessionStorage.setItem('rentDetails', JSON.stringify({
        sabha_code: this.rentObj.pra_sabha,
        remark: this.rentObj.rentdes,
        month: this.currentDate.getMonth() + 1,
        year: this.currentDate.getFullYear(),
        invoiceNum: InvouceNum,
      }));
      this.$router.push("/ShoprentInvoice2");
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.shoprent-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 1150px; margin: 0 auto; }

/* Login prompt */
.login-prompt { display: flex; align-items: center; justify-content: center; min-height: 80vh; }
.login-card {
  background: #fff; border-radius: 1.4rem; padding: 4rem 3.5rem;
  text-align: center; max-width: 420px; width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,0.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.8rem; }
.login-card p  { font-size: 1.4rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1rem 2.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.45rem; font-weight: 600;
  text-decoration: none; transition: all 0.2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.35); }

/* Page header */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.2rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }
.history-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.85rem 1.8rem; border: 1.5px solid #c2440a;
  color: #c2440a; background: #fff; border-radius: 0.8rem;
  font-size: 1.35rem; font-weight: 500; text-decoration: none; transition: all 0.2s; white-space: nowrap;
}
.history-btn svg { width: 1.6rem; height: 1.6rem; }
.history-btn:hover { background: #c2440a; color: #fff; }

/* Cards */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2rem 2.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  margin-bottom: 1.6rem;
}
.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 1.8rem; padding-bottom: 1.4rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 3.8rem; height: 3.8rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.8rem; height: 1.8rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.75rem; color: #1c0f0a; margin: 0 0 0.15rem; }
.card-desc  { font-size: 1.25rem; color: #9a8070; margin: 0; }

/* Fields */
.field-group { display: flex; flex-direction: column; gap: 0.5rem; }
.field-label { display: flex; align-items: center; gap: 0.5rem; font-size: 1.2rem; font-weight: 600; color: #4a3028; }
.field-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }
.req { color: #c2440a; }
.input-wrap { position: relative; }
.field-input {
  width: 100%; padding: 0.75rem 1.1rem;
  font-size: 1.3rem; font-family: 'DM Sans', sans-serif;
  color: #1c0f0a; background: #faf8f6;
  border: 2px solid #e5ddd5; border-radius: 0.7rem; transition: all 0.2s;
}
.field-input:focus { outline: none; border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09); }
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input::placeholder { color: #b0a09a; }
.field-textarea { min-height: 8rem; resize: vertical; }
.select-input { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 3rem; }
.select-chevron {
  position: absolute; right: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; color: #9a8070; pointer-events: none;
}
.select-chevron svg { width: 100%; height: 100%; }
.error-mess { font-size: 1.15rem; color: #b91c1c; margin: 0; }
.error-mess::before { content: '⚠ '; }

/* Info banner */
.info-banner {
  display: flex; gap: 1.2rem; align-items: flex-start;
  background: #fdf8f0; border: 1px solid #f0ddc8;
  border-radius: 0.9rem; padding: 1.4rem 1.6rem; margin-bottom: 1.6rem;
}
.info-icon { width: 2.2rem; height: 2.2rem; flex-shrink: 0; margin-top: 0.1rem; }
.info-icon svg { width: 100%; height: 100%; stroke: #c2440a; }
.info-text p { font-size: 1.25rem; color: #4a3028; margin: 0 0 0.5rem; line-height: 1.65; }
.info-text p:last-child { margin: 0; }
.sin-text { color: #7c5a48 !important; font-style: italic; }

/* Table */
.table-wrap { overflow-x: auto; border: 1px solid #e5ddd5; border-radius: 0.8rem; }
.data-table { width: 100%; border-collapse: collapse; font-size: 1.2rem; }
.data-table thead tr { background: #f0ebe3; }
.data-table th {
  padding: 0.95rem 1rem; text-align: left;
  font-size: 1.1rem; font-weight: 600; color: #4a3028;
  text-transform: uppercase; letter-spacing: 0.04em;
  border-bottom: 2px solid #e5ddd5; white-space: nowrap; line-height: 1.4;
}
.th-sub { font-weight: 400; text-transform: none; letter-spacing: 0; color: #9a8070; }
.data-table td {
  padding: 0.9rem 1rem; color: #1c0f0a;
  border-bottom: 1px solid #f0ebe3; vertical-align: middle; transition: background 0.15s;
}
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #fdf9f6; }
.data-table tbody tr:nth-child(even) { background: #faf8f6; }
.data-table tbody tr:nth-child(even):hover { background: #fdf9f6; }
.selected-row { background: #fff4ef !important; }
.selected-row td:first-child { border-left: 3px solid #c2440a; }
.num-col    { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.center-col { text-align: center; }
.fine-col   { color: #b91c1c; font-weight: 600; }
.total-col  { font-weight: 700; }
.shop-num   { font-weight: 700; color: #7c2d12; text-align: center; }
.month-cell { white-space: nowrap; color: #4a3028; }
.empty-row  { text-align: center; color: #9a8070; font-size: 1.4rem; padding: 3.5rem !important; font-style: italic; }

/* Custom checkbox */
.custom-check-wrap { display: flex; align-items: center; justify-content: center; cursor: pointer; }
.hidden-check { display: none; }
.custom-check {
  width: 2.1rem; height: 2.1rem; border-radius: 0.45rem;
  border: 2px solid #d4c8be; background: #faf8f6;
  display: flex; align-items: center; justify-content: center; transition: all 0.18s;
}
.custom-check:hover { border-color: #c2440a; }
.custom-check.checked {
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-color: transparent; box-shadow: 0 2px 8px rgba(124,45,18,0.3);
}
.custom-check svg { width: 1.3rem; height: 1.3rem; stroke: #fff; }

/* Form actions */
.form-actions {
  display: flex; align-items: center; justify-content: space-between;
  gap: 1.2rem; flex-wrap: wrap;
  padding-top: 1.6rem; margin-top: 1.5rem; border-top: 1px solid #f0e6de;
}
.selection-summary {
  display: flex; align-items: center; gap: 0.6rem;
  font-size: 1.3rem; font-weight: 600; color: #166534;
  background: #dcfce7; border: 1px solid #bbf7d0;
  border-radius: 99px; padding: 0.5rem 1.3rem;
}
.selection-summary svg { width: 1.5rem; height: 1.5rem; stroke: #166534; }
.no-selection {
  display: flex; align-items: center; gap: 0.6rem;
  font-size: 1.25rem; color: #9a8070;
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 99px; padding: 0.5rem 1.3rem;
}
.no-selection svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; }
.submit-btn {
  display: inline-flex; align-items: center; gap: 0.7rem;
  padding: 0.95rem 2.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.45rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28); transition: all 0.2s;
}
.submit-btn svg { width: 1.7rem; height: 1.7rem; }
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }

/* Notice card */
.notice-card { display: flex; align-items: flex-start; gap: 1.8rem; border-color: #fde8c8; background: #fffbf5; }
.notice-icon-wrap {
  width: 4.5rem; height: 4.5rem; flex-shrink: 0;
  background: #fff4e0; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.notice-icon-wrap svg { width: 2.4rem; height: 2.4rem; stroke: #c2440a; }
.notice-title { font-family: 'DM Serif Display', serif; font-size: 1.65rem; color: #1c0f0a; margin: 0 0 0.5rem; }
.notice-msg   { font-size: 1.3rem; color: #4a3028; margin: 0 0 0.4rem; line-height: 1.5; }
.notice-sin   { font-size: 1.2rem; color: #9a8070; margin: 0; font-style: italic; }

/* Responsive */
@media (max-width: 900px) { .shoprent-page { padding: 1.5rem 1rem 3rem; } .page-title { font-size: 2.2rem; } }
@media (max-width: 768px) {
  .page-header { flex-direction: column; }
  .form-card   { padding: 1.5rem; }
  .form-actions { flex-direction: column; align-items: stretch; }
  .submit-btn  { justify-content: center; }
}
@media (max-width: 520px) { .page-title { font-size: 1.9rem; } .notice-card { flex-direction: column; } }
</style>